import React, { useEffect, useState } from 'react'
import { DataTable } from 'primereact/datatable'
import { useNavigate, useParams } from 'react-router-dom'
import { Column } from 'primereact/column'
import { deleteService } from '../Editor/Functions'
import { Flex, Modal, Text, Button, Spinner } from '../../../Components'
import { useCQuery } from '../../../Services/QueryCache'
import { columnProps } from '../../Reports/Functions'

export function FornitoriList () {
  const { codSociety } = useParams()
  const { data: users = [], isSuccess } = useCQuery(['fornitori', codSociety])
  const [usersTable, setUsersTable] = useState([])
  const navigate = useNavigate([])

  useEffect(() => {
    isSuccess && setUsersTable(users.map((r) => r))
  }, [users])

  const BtnActions = ({ id }) => {
    const [modalVisible, setModalVisible] = useState(false)
    return (
      <Flex width={160} row>
        <Modal visible={modalVisible} header='Cancellazione Fornitore' onHide={() => setModalVisible(false)}>
          <Flex fw>
            <Text value='Vuoi cancellare questo fornitore?' />
            <Flex fw row jb style={{ marginTop: 20 }}>
              <Button label='Annulla' icon='bin' onClick={() => setModalVisible(false)} />
              <Button label='Conferma' icon='check' onClick={() => deleteService(id)} />
            </Flex>
          </Flex>
        </Modal>
        <Button round tooltip='Modifica' icon='edit' onClick={() => navigate('/fornitori/' + codSociety + '/' + id)} />
        <Button style={{ marginLeft: 20 }} round tooltip='Elimina' icon='bin' onClick={() => setModalVisible(true)} />
      </Flex>
    )
  }

  if (!isSuccess) return <Spinner />
  return (
    <Flex fw fh js>
      <Flex fw row je ae>
        <Button label='Crea Nuovo' icon='plus' style={{ marginRight: 10 }} onClick={() => navigate('/fornitori/' + codSociety + '/new')} />
      </Flex>
      <Text value='Lista Fornitori' size={20} bold />
      <DataTable
        style={{ width: '100%' }} filterDisplay='row' sortField='createdAt' sortOrder={-1} className='TableSignatures'
        value={usersTable} emptyMessage='Nessun fornitore trovato' responsiveLayout='scroll' paginator rows={10}
      >
        <Column field='codice' {...columnProps('Codice')} />
        <Column field='codSociety' {...columnProps('Codice Società')} />
        <Column field='exclude' {...columnProps('Escluso')} body={({ exclude }) => exclude ? 'Si' : 'No'} />
        <Column style={{ border: 'none', width: 140, height: 15, textAlign: 'center' }} body={(props) => <BtnActions {...props} />} />
      </DataTable>
    </Flex>
  )
}
